module.exports = __webpack_public_path__ + "img/color_currents_icon.5e2dc50c.svg";